export default {
    title: 'WordPress Hosting',
    wp: 'WordPress',
    wp_hosting: 'WordPress Hosting',
    wp_hosting_detail: 'WordPress Hosting Detail',
    wp_hosting_info: 'WordPress Hosting Information',
    wp_hosting_management: 'WordPress Management',
    reinstall_wp: 'Reinstall WP',
    server_name: 'Server name',
    package: 'Package',
    reg_date: 'Reg Date',
    due_date: 'Exp Date',
    auto_renew: 'Auto Renew',
    server_status: 'Server Status',
    status: 'Status',
    upgrade_wordpress_hosting: 'Upgrade WordPress Hosting',
    upgrade_warning:
        'You need to pay this order within the day, otherwise the order will be deleted',
    package_name: 'Package Name',
    payment_plan: 'Payment Plan',
    wp_hosting_extend: 'Extend WordPress Hosting',
    action: 'Action',
    domain: 'Domain',
    wp_admin: 'WP Admin',
    name_server: 'Name Servers',
    version: 'Version',
    name: 'Name',
    rating: 'Rating',
    link: 'Link',
    accept_type:
        'Please compress and upload your theme under.zip format. The maximum file size {size}',
    plugin_accept_type:
        'Please compress and upload your plugin under.zip format. The maximum file size {size}',
    author: 'Author',
    management_tab: {
        overview: 'Overview',
        backups: 'Backups',
        file_database: 'File & Database',
        themes: 'Themes',
        plugins: 'Plugins',
        security: 'Security',
        configuration: 'Configuration',
    },
    reinstalling_title: 'Your WordPress site is being installed.',
    reinstalling_des:
        'You will receive a notification upon completion. Please refresh the page afterward.',
    reinstall_failed_title: 'Your WordPress site installation failed.',
    reinstall_failed_des:
        'An error occurred during reinstall, please try reinstall again.',
    reinstall_warning:
        'All data will be lost! Ensure you have a backup before reinstalling',
    reinstall_confirm_message:
        'After reinstall, all previous data and settings will be deleted',
    reinstall_confirm_question: 'Do you want to reinstall?',
    theme_tab: {
        installed: 'Installed',
        add_themes: 'Add themes',
        upload_theme: 'Upload theme',
        active_theme: 'Active theme',
        inactive_themes: 'Inactive themes',
        search_theme: 'Search theme',
        active_after_upload: 'Active the theme after upload',
    },
    overview_tab: {
        themes: 'Themes',
        plugins: 'Plugins',
        up_to_date: 'Up to date',
        updated: 'Updated',
        out_of_date: 'Out of date',
        overview: 'OVERVIEW',
        site_info: 'SITE INFO',
        website_name: 'Website name',
        wp_version: 'WordPress version',
        upgrade_now_tooltip:
            'Upgrade one of the following versions: {versions}',
        disk_usage: 'Disk usage',
        used: 'used',
    },
    configuration: {
        title: 'Configuration',
        configs: {
            auto_upgrade_code: {
                title: 'Auto Upgrade WordPress Core',
                tooltip:
                    'Select the automatic upgrade preference for WordPress core',
                options: {
                    0: 'Do not Auto Upgrade',
                    1: 'Upgrade to latest version available (Major as well as Minor)',
                    2: 'Upgrade to Minor versions only',
                },
            },
            auto_upgrade_themes: {
                title: 'Auto Upgrade WordPress Themes',
                tooltip:
                    'If enabled, all WordPress themes for this installation will be automatically upgraded to the latest version (every 24 hours)',
            },
            auto_upgrade_plugins: {
                title: 'Auto Upgrade WordPress Plugins',
                tooltip:
                    'If enabled, all WordPress plugins installed for this installation will be automatically upgraded to the latest version (every 24 hours)',
            },
            search_engine: {
                title: 'Search Engine Visibility',
                tooltip:
                    'If enabled, your website will be crawled by search engines. If your site is under construction you can disable this and enable it when your site is live. Default: Enabled',
            },
            cron: {
                title: 'WordPress Cron (wp-cron.php)',
                tooltip:
                    'If disabled, WordPress cron will be disabled and a cron job will be added in your control panel to be executed twice an hour. Default: Enabled',
            },
            debug: {
                title: 'Debug Mode',
                tooltip:
                    'If enabled, WordPress debugging mode will be enabled which will help you find the cause of an error in case of critical error.<br />Note: Do not leave this enabled on a production site. Default: Disabled',
            },
        },
    },
    create_backup_section: {
        title: 'Backups',
        description: 'Create backups of your website regularly',
        create_backup: 'Create backup',
    },
    modal_backup_wp: {
        title: 'Backing Up WordPress',
        backup_operation: {
            title: 'Select Backup Operation(s)',
            backup_directory: 'Backup Directory',
            backup_directory_des:
                'If you check this the entire folder will be backed up.',
            backup_database: 'Backup Database',
            backup_database_des:
                'If you check the database will also be backed up.',
            backup_note: 'Backup Note',
            tooltip_backup_note: 'You can save a note for your reference',
        },
        wp_info: {
            title: 'Info',
            software: 'Software',
            ins_number: 'Installation Number',
            version: 'Version',
            url: 'URL',
        },
        in_progress_title: 'Backing up the WordPress ({progressPercent}%)',
        in_progress_des:
            'NOTE: This may take 3-4 minutes. You can exit if you wish !',
        backup_done: 'The backup is created successfully',
    },
    backup_failed: {
        title: 'The following errors were found:',
        reason1:
            'Failed to write to the backup file. Please check you have enough disk quota available.',
        reason2: 'The backup utility could not back up the files.',
    },
    plugin_tabs: {
        installed: 'Installed',
        add_plugins: 'Add plugins',
        upload_plugin: 'Upload plugin',
        search_theme: 'Search plugin',
        active_after_upload: 'Active the plugin after upload',
    },
    message: {
        theme_delete_confirm:
            'Are you sure you want to delete the {themeName} theme?',
        theme_activate_confirm:
            'Are you sure you want to activate the {themeName} theme?',
        theme_upgrade_confirm:
            'Are you sure you want to upgrade the {themeName} theme?',
        enter_theme: 'Please enter theme name',
        upload_theme_success: 'Theme installed successfully',
        enter_plugin: 'Please enter plugin name',
        upload_plugin_success: 'Plugin installed successfully',
        reinstall_success: 'Your WordPress reinstalled successfully',
        turn_on_ssl_confirm:
            'Are you sure you want to turn on SSL Certificate?',
        turn_off_ssl_confirm:
            'Are you sure you want to turn off SSL Certificate?',
        turn_on_enforce_https_confirm:
            'Are you sure you want to turn on Enforce HTTPS?',
        turn_off_enforce_https_confirm:
            'Are you sure you want to turn off Enforce HTTPS?',
        revoke_db_account_confirm:
            'Are you sure you want to revoke this Database account?',
        revoke_ftp_account_confirm:
            'Are you sure you want to revoke this FTP account?',
        restore_backup_confirm:
            'Are you sure you want to restore the installation?',
    },
    list_backups: {
        title: 'Previous backups',
        description: 'Description',
        file_name: 'File name',
        size: 'Size',
        version: 'Version',
    },
    modal_restore_wp: {
        title: 'Restoring WordPress',
        restore_directory: 'Restore Directory',
        restore_directory_des:
            'If you check this the entire folder will be restored.',
        delete_files: 'Delete existing files/folders',
        delete_files_des:
            'If checked existing files/folders will be deleted and then the backup files will be restores.{lineBreak}Note: Please make sure that you chose  Full Backup while creating this backup.',
        restore_database: 'Restore Database',
        restore_database_des:
            'If you check the database will also be restored.',
        in_progress_title: 'Restoring the backup ({progressPercent}%)',
        in_progress_des:
            'NOTE: This may take 3-4 minutes. You can exit if you wish !',
        restore_done: 'Your backup is restored successfully',
    },
    installed_plugin_item: {
        version: 'Version',
        upgrade_to_version: 'Upgrade to version {version}',
        activate_plugin_des:
            'Are you sure you want to activate the {pluginName} plugin?',
        deactivate_plugin: 'Deactivate plugin',
        deactivate_plugin_des:
            'Are you sure you want to deactivate the {pluginName} plugin?',
    },
    file_and_db: {
        access_time: {
            hour_1: 'Access for 1 hour',
            hour_12: 'Access for 12 hours',
            hour_24: 'Access for 24 hours',
        },
        ftp_access: 'FTP ACCESS',
        ftp_access_des:
            'Access your website files through an FTP client to edit your website’s code and troubleshoot any issues.{lineBreak}We recommend you to perform a backup before changing any file.',
        access: 'Access',
        expire_time: 'Expires in {expireTime} seconds',
        server: 'Server',
        port: 'Port',
        username: 'Username',
        password: 'Password',
        db_access: 'DATABASE ACCESS',
        db_access_des:
            'Access your website Database through phpMyAdmin.{lineBreak}Please do not use these database details in the WordPress configuration file (wp-config.php).{lineBreak}Should you need the details for wp-config, please do not hesitate to contact our Customer Support.',
        go_to_db_tool: 'Go to PHPMyAdmin',
    },
    reinstall: {
        modal_title: 'Config WP',
        theme: 'Theme',
        plugins: 'Plugins',
        warning: {
            title: 'Please note the warnings below:',
            text_1: 'After reinstalling, all previous data, backup and settings will be delete.',
            text_2: 'Make sure you store your backups before performing this action.',
            go_to_backup: 'Go to backup',
        },
    },
    security: {
        ssl_certificate: {
            title: 'SSL Certificate',
            description:
                'An SSL helps keep information like logins, passwords, and customers’ credit card numbers safe.',
        },
        enforce_https: {
            title: 'Enforce HTTPS',
            description:
                'Force a secure connection to your website to provide a safe and secure browsing experience to your visitors.',
        },
        verifying_message: 'Your SSL Certificate is being verified',
        not_support_ssl:
            'SSL certificate is not available for free domains. To obtain an SSL certificate, please use your own domain.',
        ssl_change_time_message:
            'System being processed your SSL configuration.',
        ssl_type: {
            none: 'No SSL',
            custom: 'Custom SSL',
            free: 'Free SSL',
        },
    },
    update_domain: 'Changing your main domain name',
    new_main_domain_name: 'New main domain name',
    new_main_domain_name_placeholder: 'Please enter your new domain name',
    new_main_domain_name_warning: {
        title: 'IMPORTANT! What this change means',
        text_1: {
            title: 'Duplicate Domain Names',
            content:
                'Your new main domain name should not exist in this or any other 1Byte WordPress hosting account',
        },
        text_2: {
            title: 'Automatic Updates',
            content:
                'Any content and/or files, email and FTP accounts will be reassigned from your previous domain name to your new one',
        },
        text_3: {
            title: 'Manual Updates Required',
            content:
                'Softaculous App installations and their backups, however, will not be reassigned from your previous domain name to your new one. They should be updated manually',
        },
    },
    new_main_domain_error:
        'It looks like this domain name is either banned, already exists, or contains a trademark.',
    understand_and_agree: 'I understand and agree',
    modal_upgrade_wp_version: {
        title: 'Upgrading WordPress',
        in_progress_title: 'Upgrading WordPress ({progressPercent}%)',
        in_progress_des:
            'NOTE: This may take 3-4 minutes. You can exit if you wish !',
        upgrade_done: 'WordPress has been upgraded successfully',
        create_backup: 'Create Backup',
        create_backup_des: 'Create a Backup before upgrading',
        select_a_version: 'Select a version to upgrade to',
        backup_option: 'Backup Options',
        backup_option_des: 'Choose full backup or advanced options',
        backup_full: 'Full Backup (Default)',
        backup_advanced: 'Advanced Options',
        backup_dir: 'Backup Directory',
        backup_db: 'Backup Database',
        upgrade_note:
            '{noteBold}: This software will perform an upgrade using its own upgrade utility. To complete the upgrade, please visit the URL that will be shown once the files have been copied.{lineBreak}{lineBreak}Its recommended that you take a backup of the installation before upgrading.',
    },
    hosting_package: 'WordPress Hosting Package',
    modal_update_domain: {
        free_domain: 'Free Domain',
        new_domain: 'New Domain',
    },
    subdomain_placeholder: 'Please input subdomain',
    warning_out_date_fpt_domain:
        'Your FTP and phpMyAdmin URL are outdated. {clickHere} for updates. This update will verify SSL again',
    new_domain_form_not_support_ssl:
        'Please note: SSL certificate is not available for free domains',
    change_password: 'Change WordPress Hosting Password',
    change_ssl_certificate: {
        modal_title: 'Change SSL Certificate',
        options: {
            no_ssl: 'No SSL Certificate',
            free_ssl: 'Free SSL Certificate',
            custom_ssl: 'Custom SSL Certificate',
        },
        custom_ssl_description:
            'Allow your website to talk securely between the browser and the server. To enable this, please upload the required files below',
        custom_ssl: {
            ssl_certificate: {
                label: 'SSL Certificate',
                placeholder: 'Enter SSL Certificate',
            },
            private_key: {
                label: 'Private Key',
                placeholder: 'Enter Private Key',
            },
            ca_bundle: {
                label: 'CA Bundle (Optional)',
                placeholder: 'Enter CA Bundle',
            },
        },
    },
    new_domain_form_support_ssl:
        'Please note: Free SSL certificate will be applied to new domain name',
};
